import React from 'react';

const Copy = ({
  children,
  small = false,
  normal = false,
  large = false,
  medium = false,
  color = "#181818",
  alignRight = false,
  alignLeft = false,
  padding = 0,
}) => {

  const classList = ['copy'];
  let padStyle;

  if (small) classList.push('Small');
  else if (normal) classList.push('Normal');
  else if (medium) classList.push('Medium');
  else if (large) classList.push('Large');

  if (alignRight) {
    classList.push('Align-right');
    padStyle = { paddingRight: padding };
  } else if (alignLeft) {
    classList.push('Align-left');
    padStyle = { paddingLeft: padding };
  }
  

  return (
    <p
      style={{ color: color, ...padStyle }}
      className={classList.join(' ')}
    >
      {children}
    </p>
  );
};

export default Copy;


// WEBPACK FOOTER //
// ./src/components/theme/Copy/Copy.jsx